<div class="modal-header">
    <h4 class="modal-title">Registro de Actualización de Stock</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="form">
        <div class="row">
            <div class="d-flex gap-4">
                <div class="mb-3 w-100">
                    <label for="fecha">Fecha</label>
                    <input type="date" class="form-control" id="fecha" formControlName="fecha" [ngClass]="{'is-invalid': form.controls['fecha'].errors && form.controls['fecha'].touched}">
                    <div class="invalid-feedback">
                        Debe ingresar un valor en el campo
                    </div>
                </div>
    
                <div class="mb-3 w-100">
                    <label for="tipo_actualizacion_id">Tipo de actualización</label>
                    <ng-select placeholder="Buscar Tipo de Actualización..." id="tipo_actualizacion_id" formControlName="tipo_actualizacion_id" [appendTo]="'body'" [ngClass]="{'is-invalid': form.controls['tipo_actualizacion_id'].errors && form.controls['tipo_actualizacion_id'].touched}">
                        <ng-option *ngFor="let tipo_actulizacion of tipo_actulizaciones" [value]="tipo_actulizacion.id">{{tipo_actulizacion.nombre}}</ng-option>
                    </ng-select>
                    <div class="invalid-feedback">
                        Debe ingresar un valor en el campo
                    </div>
                </div>
    
                <div class="mt-4">
                    <button class="btn btn-primary" (click)="agregarTipo()"><i class="fas fa-plus"></i></button>
                </div>
            </div>

        </div>
        <div class="mb-3 col-12">
            <label for="detalle">Detalle</label><label class="campo-opcional">(Opcional)</label>
            <textarea class="form-control" id="detalle" rows="3" formControlName="detalle"></textarea>
        </div>

        <form [formGroup]="form_producto">
            <div class="row">
                <div class="mb-3 col-sm-6">
                    <label for="productos">Productos</label>
                    <ng-select placeholder="Buscar productos..." id="producto_id" formControlName="producto_id" [appendTo]="'body'" [ngClass]="{'is-invalid': form_producto.controls['producto_id'].errors && form_producto.controls['producto_id'].touched}">
                        <ng-option *ngFor="let producto of productos" [value]="producto.id">{{producto.nombre}}</ng-option>
                    </ng-select>
                    <div class="invalid-feedback">
                        Debe ingresar un valor en el campo
                    </div>
                </div>
                <div class="mb-3 col-4">
                    <label for="monto">Cantidad</label>
                    <input type="text" class="form-control" id="cantidad" formControlName="cantidad" [ngClass]="{'is-invalid': form_producto.controls['cantidad'].errors && form_producto.controls['cantidad'].touched}" (keypress)="formatter.validateAllNumber($event)" mask="separator.0" thousandSeparator="." [allowNegativeNumbers]="true">
                    <div class="invalid-feedback">
                        Debe ingresar un valor en el campo
                    </div>
                </div>
                <div class="mb-3 my-4 col-sm-2">
                    <button type="button" class="btn btn-primary w-100" (click)="agregar()">
                        Agregar
                    </button>
                </div>
    
                <div class="col-12">
                    <kuv-table [useFilter]="false" [usePagination]="false" [columns]="columnas" [actions]="acciones" [useSort]="false" [useIndex]="false" [isRounded]="true" [items]="linea"></kuv-table>
                </div>
            </div>
        </form>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="registrar()">Registrar</button>
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('Cancel click')">Cancelar</button>
</div>